//封装axios
import axios from "axios";
// import { Message, Loading } from 'element-ui';
// 封装loading开启和结束函数
let loading;
// function startLoading(){
//   loading = Toast.loading.service({
//     lock:true,
//     text:'拼命加载中...',
//     background:'rgba(0,0,0,0.7)'
//   })
// }
// function endLoading(){
//   loading.close()
// }
 
//1: 创建axios实例
const service = axios.create({
  //基地址
  baseURL:"https://zfb-front.xingtu-group.com/devv",
    //  baseURL:"http://192.168.99.198:20710",
  //baseURL:env.dev.baseUrl,
  settimeout: 5000,
});
//2:请求拦截
service.interceptors.request
  .use((config) => {
    //在发送请求之前做些什么，比如验证token之类的
    if(localStorage.eleToken){
      config.headers.Authorization = localStorage.eleToken
    }
    //开启loading
    // startLoading();
    return config;
  },(error) => {
    //对错误请求做些什么
    //关闭loading
    // endLoading();
    return Promise.reject(error)
  })
 
//3:响应拦截
service.interceptors.response.use(
  (response) =>{
    //关闭loading
    // endLoading();
    return response.data;
  },
  (error) => {
    //对错误请求做些什么
    const {status} = error.response
    Toast.fail('')
    //关闭loading
    // endLoading();
    //提示信息
    Toast.fail(error.response.data.msg)
    return Promise.reject(error)
})
//4:抛出axios对象实例
export default  service;
